const RESOLUTION = {
  SMALL: 576,
  MEDIUM: 768,
  LARGE: 992,
  EXTRA_LARGE: 1200,
};

const SIZES = {
  SMALL: `${RESOLUTION.SMALL}px`,
  MEDIUM: `${RESOLUTION.MEDIUM}px`,
  LARGE: `${RESOLUTION.LARGE}px`,
  EXTRA_LARGE: `${RESOLUTION.EXTRA_LARGE}px`,
};

const DEVICES = {
  SMALL: `screen and (min-width: ${SIZES.SMALL})`,
  MEDIUM: `screen and (min-width: ${SIZES.MEDIUM})`,
  LARGE: `screen and (min-width: ${SIZES.LARGE})`,
  EXTRA_LARGE: `screen and (min-width: ${SIZES.EXTRA_LARGE})`,
};

export { RESOLUTION, SIZES, DEVICES };
